import { render } from "./Random-Quotes.vue?vue&type=template&id=72d112d2&scoped=true"
import script from "./Random-Quotes.vue?vue&type=script&lang=js"
export * from "./Random-Quotes.vue?vue&type=script&lang=js"

import "./Random-Quotes.vue?vue&type=style&index=0&id=72d112d2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d112d2"]])

export default __exports__